/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Provider PagoPA configurato. Valori previsti:   -*DEDA_GROUP* (DedaGroup OpenWeb)  -*MAGGIOLI*  -*PUBLISYS* (GovPay)
 */
export enum TipoPagoPa {

    DEDA_GROUP = 'DEDA_GROUP',

    MAGGIOLI = 'MAGGIOLI',

    PUBLISYS = 'PUBLISYS'
}

